import Icon from '@mdi/react';
import { Box, IconButton, Link } from '@mui/material';
import classnames from "classnames";
import { Route, Routes, useNavigate } from "react-router-dom";

// icons
import {
  mdiFacebook as FacebookIcon,
  mdiGithub as GithubIcon,
  mdiTwitter as TwitterIcon,
} from '@mdi/js';

// styles
import useStyles from "./styles";

// components
import Header from "../Header";
import Sidebar from "../Sidebar";

// pages

// context
import { useLayoutState } from "../../context/LayoutContext";
import MesGPS from "../../pages/Nouveau/mesGPS/MesGPS";

function Layout() {
  const classes = useStyles();
  const layoutState = useLayoutState();
  const navigate = useNavigate(); // remplace props.history

  return (
    <div className={classes.root}>
      <>
        <Header navigate={navigate} />
        <Sidebar />
        <div
          className={classnames(classes.content, {
            [classes.contentShift]: layoutState.isSidebarOpened,
          })}
        >
          <div className={classes.fakeToolbar} />
          <Routes>
            {/* Redirections et pages */}
            <Route path="/MesGPS" element={<MesGPS />} />
          </Routes>

          <Box
            mt={5}
            width="100%"
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <div>
              <p>Copyright &copy; 2023 - {new Date().getFullYear()} par SEVOB-Sarl</p>
            </div>
            <div>
              <Link href="https://www.facebook.com/flatlogic" target="_blank">
                <IconButton aria-label="facebook">
                  <Icon path={FacebookIcon} size={1} color="#6E6E6E99" />
                </IconButton>
              </Link>
              <Link href="https://twitter.com/flatlogic" target="_blank">
                <IconButton aria-label="twitter">
                  <Icon path={TwitterIcon} size={1} color="#6E6E6E99" />
                </IconButton>
              </Link>
              <Link href="https://github.com/flatlogic" target="_blank">
                <IconButton aria-label="github" style={{ marginRight: -12 }}>
                  <Icon path={GithubIcon} size={1} color="#6E6E6E99" />
                </IconButton>
              </Link>
            </div>
          </Box>
        </div>
      </>
    </div>
  );
}

export default Layout;